/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GearPrior } from './GearPrior';
import {
    GearPriorFromJSON,
    GearPriorFromJSONTyped,
    GearPriorToJSON,
    GearPriorToJSONTyped,
} from './GearPrior';
import type { SpeciesLengthPrior } from './SpeciesLengthPrior';
import {
    SpeciesLengthPriorFromJSON,
    SpeciesLengthPriorFromJSONTyped,
    SpeciesLengthPriorToJSON,
    SpeciesLengthPriorToJSONTyped,
} from './SpeciesLengthPrior';
import type { HandPrior } from './HandPrior';
import {
    HandPriorFromJSON,
    HandPriorFromJSONTyped,
    HandPriorToJSON,
    HandPriorToJSONTyped,
} from './HandPrior';

/**
 * Measured reference dimensions the model should prefer over recall
 * (app/size_estimate/priors_data.py). None in production today.
 * @export
 * @interface PriorContext
 */
export interface PriorContext {
    /**
     * 
     */
    hands: Array<HandPrior>;
    /**
     * 
     */
    gear: Array<GearPrior>;
    /**
     * 
     */
    species: Array<SpeciesLengthPrior>;
}

/**
 * Check if a given object implements the PriorContext interface.
 */
export function instanceOfPriorContext(value: object): value is PriorContext {
    if (!('hands' in value) || value['hands'] === undefined) return false;
    if (!('gear' in value) || value['gear'] === undefined) return false;
    if (!('species' in value) || value['species'] === undefined) return false;
    return true;
}

export function PriorContextFromJSON(json: any): PriorContext {
    return PriorContextFromJSONTyped(json, false);
}

export function PriorContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriorContext {
    if (json == null) {
        return json;
    }
    return {
        
        'hands': ((json['hands'] as Array<any>).map(HandPriorFromJSON)),
        'gear': ((json['gear'] as Array<any>).map(GearPriorFromJSON)),
        'species': ((json['species'] as Array<any>).map(SpeciesLengthPriorFromJSON)),
    };
}

export function PriorContextToJSON(json: any): PriorContext {
    return PriorContextToJSONTyped(json, false);
}

export function PriorContextToJSONTyped(value?: PriorContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hands': ((value['hands'] as Array<any>).map(HandPriorToJSON)),
        'gear': ((value['gear'] as Array<any>).map(GearPriorToJSON)),
        'species': ((value['species'] as Array<any>).map(SpeciesLengthPriorToJSON)),
    };
}

